import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ClinicalOffering from "@/pages/ClinicalOffering";

export const Route = createFileRoute("/es/servicios/clinical-solutions/gestion-de-la-seguridad-clinica")({
  head: () => buildRouteHead("/es/servicios/clinical-solutions/gestion-de-la-seguridad-clinica"),
  component: ClinicalOffering,
});

